import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { compose, withProps } from 'recompose';
import { withFixedSegmentCategory } from '@sparefoot/react-core/segment';

import { Container } from 'components/core/Page';
import { withSearchHandler } from 'decorators';
import { H1, H2, Paragraph } from 'components/core/Typography';
import { FilterSearchBox } from 'components/search/FilterSearchBox';
import BenefitsAccordion from './BenefitsAccordion';
import Arrow from './Arrow';

import './FilterSearchHero.scss';

export const enhance = compose(
	withFixedSegmentCategory('informed search'),
	withProps(() => ({
		additionalSearchParams: {
			informedSearch: true
		}
	})),
	withSearchHandler
);

export const FilterSearchHeroHeading = ({ headline, subtitle }) => (
	<div className="heading">
		<H1
			weight="extraBold"
			color="secondaryBlue"
		>
			{headline}
		</H1>
		<H2
			color="secondaryBlue"
		>
			{(!subtitle || !subtitle.length) ?
				<Fragment>
					<strong>Enter Your Zip Code</strong> to Find the Storage Unit You Need at the Price You Want
				</Fragment> : subtitle}

		</H2>
	</div>
);

FilterSearchHeroHeading.propTypes = {
	headline: PropTypes.string.isRequired,
	subtitle: PropTypes.string
};

/**
 * Filter Search Hero
 * This component replaced the InformedSearch component after it won the
 * sf_11265_filter_search_clp_hero experiment.
 */
export function FilterSearchHero({
	headline,
	subtitle,
	handleSearch, // from withSearchHandler
	totalListings,
	searchLocation
}) {
	return (
		<div className={classnames('filter-search-hero')}>
			<Container>

				<div className="hero-body">
					<FilterSearchHeroHeading headline={headline} subtitle={subtitle} />
					<div className="search-container">
						<Arrow />
						<Paragraph>
							Refine your search of <strong>{totalListings} storage facilities</strong>
							&nbsp;for more relevant results.
						</Paragraph>
						<FilterSearchBox
							searchLocation={searchLocation}
							handleSearch={handleSearch}
							id="filters-hero-search"
						/>
					</div>
				</div>

				<BenefitsAccordion
					className="hero-footer"
					title="Benefits of SelfStorage.com"
					items={[
						'Search and Compare Storage Prices Nearby',
						'Reserve a Storage Unit for Free Until You Move In',
						'No Obligation to Rent After Reserving',
						'Find Deals Only Available on SelfStorage.com',
						'No Credit Card Required to Reserve',
						'Trusted by Thousands of Storage Tenants'
					]}
				/>
			</Container>
		</div>
	);
}

FilterSearchHero.propTypes = {
	totalListings: PropTypes.number,
	headline: PropTypes.string.isRequired,
	subtitle: PropTypes.string,
	searchLocation: PropTypes.object,
	handleSearch: PropTypes.func.isRequired
};

export default enhance(FilterSearchHero);
